export default __webpack_public_path__ + "static/media/starten.7baa0640.png";